import React from "react";
import { Link } from "react-router-dom";
import { Car } from "lucide-react";

export default function Footer() {
  const cols = [
    { title: "Decide", links: [["AI Advisor", "/advisor"], ["Compare Cars", "/compare"], ["Tools", "/tools"], ["Ask Expert", "/chat"]] },
    { title: "Discover", links: [["All Cars", "/cars"], ["Upcoming Launches", "/launches"], ["Latest News", "/news"], ["Best-of Guides", "/best/suvs"]] },
    { title: "Tools", links: [["EMI Calculator", "/tools/emi"], ["Ownership Cost", "/tools/ownership"], ["EV Readiness", "/tools/ev-readiness"], ["Insurance", "/tools/insurance"]] },
    { title: "Company", links: [["About", "/about"], ["Contact", "/contact"], ["Privacy", "/privacy"], ["Terms", "/terms"]] },
  ];
  return (
    <footer data-testid="site-footer" className="mt-24 bg-[#1F2937] text-neutral-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-5 gap-12">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-2xl bg-gradient-to-br from-blue-600 to-teal-500 grid place-items-center text-white shadow-md">
              <Car className="w-4 h-4" />
            </div>
            <span className="font-display font-bold tracking-tight text-white">TrendingNewCar</span>
          </div>
          <p className="mt-4 text-sm text-neutral-400 leading-relaxed">
            India&apos;s premium automobile destination — expert reviews, honest comparisons, real prices.
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-4">{c.title}</div>
            <ul className="space-y-2.5">
              {c.links.map(([label, href]) => (
                <li key={label}>
                  <Link to={href} className="text-sm text-neutral-400 hover:text-white transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs text-neutral-500 flex flex-wrap justify-between gap-3">
          <span>© {new Date().getFullYear()} TrendingNewCar. All rights reserved.</span>
          <span>Made in India · For Indian drivers</span>
        </div>
      </div>
    </footer>
  );
}
